<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Oocyte Quality Assesment</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style4" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                </div>
              </div>-->
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolStart | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEnd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        
        <div class="col-print-12" *ngIf="DenudationInfo">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family font-weight-bold">Denudation By :</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DenudationInfo.DenudationBy}}</label>
            </div>
          </div>
        </div>
        
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">OQA</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-11">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-7">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          Maturity
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-150px">
                          OCC
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family width-150px">
                    Denuded
                  </th>-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentOocyteMaturityByCycleController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.MaturityLevel}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OccCount}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.DenudedCount}}</td>-->
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Abnormal Oocytes</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-11">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-7">
              <div class="table-component margin-bottom-0px">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero border4">
                    <thead>
                      <tr>


                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Morphology
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Oocyte Count
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentOocyteMorphologyByCycleController">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Morphology}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.OocyteCount}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-4">
            <div class="row margin-left-0px">
              <div class="col-print-5">
                <label class="margin-bottom-0px font-family font-weight-normal">Total OCC:</label>
              </div>
              <div class="col-print-1 border-bot-1px">
                <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{OCCCount}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-4">
            <div class="row margin-left-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal">Total Denuded:</label>
              </div>
              <div class="col-print-1 border-bot-1px">
                <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{DenudedCount}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-4">
            <div class="row margin-left-0px">
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family font-weight-normal">Total Abnormal:</label>
              </div>
              <div class="col-print-1 border-bot-1px">
                <label class="margin-bottom-0px font-family text-align-center font-weight-bold">{{AbnormalCount}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-3">
    <label class="margin-bottom-0px font-family font-weight-normal">Frozen Oocytes:</label>
  </div>
  <div class="col-print-1 border-bot-1px">
    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
  </div>
  <div class="col-print-3">
    <label class="margin-bottom-0px font-family font-weight-normal">Discarded Oocytes:</label>
  </div>
  <div class="col-print-1 border-bot-1px">
    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
  </div>



        </div>
      </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family">Surgeon</label>
      </div>
      <div class="col-print-5 doNotPrint">
        <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
      </div>
    </div>
  </div>

  <div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-7">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-4 border-bot-1px">
            <label class="margin-bottom-0px font-family text-align-center">{{Sign1Name}}</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family"></label>
          </div>
        </div>
      </div>
      <div class="col-print-5 doNotPrint">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6 border-bot-1px">
            <label class="margin-bottom-0px font-family text-align-center"></label>
          </div>
          <div class="col-print-5">
            <label class="margin-bottom-0px font-family"></label>
          </div>
        </div>
      </div>
    </div>
  </div>-->

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
